"use client";

import { signout } from "@/lib/signout";
import Link from "next/link";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "../ui/dropdown-menu";

interface Props {
	children: React.ReactNode;
}

export const Menu: React.FC<Props> = ({ children }) => {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
			<DropdownMenuContent>
				<DropdownMenuItem asChild>
					<Link href="/user">Inventory</Link>
				</DropdownMenuItem>
				<DropdownMenuItem asChild>
					<Link href="/decks/personal">Decks</Link>
				</DropdownMenuItem>
				<DropdownMenuItem asChild>
					<Link href="/user/settings">Settings</Link>
				</DropdownMenuItem>
				<DropdownMenuItem onClick={() => signout()}>Log out</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
